module.exports = __webpack_public_path__ + "static/media/P200_Micropipette.7597cbab.svg";